@if (passFound && !loading) {
  <div slot="content">
    <ix-layout-grid class="h-100 w-100 position-relative" columns="12">
      <ix-row>
        <ix-col>
          <ix-breadcrumb>
            <ix-breadcrumb-item
              (itemClick)="navigateToPassportList()"
              [label]="'dpp.general.passport_overview' | translate"
              icon="project"
            ></ix-breadcrumb-item>
            <ix-breadcrumb-item
              (itemClick)="navigateToPassportDetail()"
              [label]="shellName || dppId"
            ></ix-breadcrumb-item>
            <ix-breadcrumb-item [label]="submodelName"></ix-breadcrumb-item>
          </ix-breadcrumb>
        </ix-col>
      </ix-row>

      <ix-row>
        <ix-col>
          <ix-content-header
            id="genericSubmodelEditorHeader"
            [hasBackButton]="true"
            (backButtonClick)="onCancel()"
            [headerTitle]="submodelName"
          >
            @if (submodelVersion) {
              <ix-pill slot="header" class="margin-top">v{{ submodelVersion }}</ix-pill>
            }
          </ix-content-header>
        </ix-col>
      </ix-row>

      <form [formGroup]="form" class="w-100">
        <ix-row class="ps-3">
          <ix-col class="ps-0" size="8">
            @for (
              element of submodel?.submodelElements ?? [];
              track element.idShort
            ) {
              <app-submodel-element
                [element]="element"
                [control]="getFormControl(element.idShort!)"
              />
            }
          </ix-col>
        </ix-row>

        <ix-row class="sticky z-2 bottom-0 bottom-background ps-3">
          <ix-col
            class="d-flex flex-row justify-content-end gap-1 bottom-background align-items-center"
            size="8">
            <ix-button variant="secondary" onkeydown="" (click)="onCancel()">
              {{ 'general.cancel' | translate }}
            </ix-button>
            <ix-button
              variant="primary"
              onkeydown=""
              (click)="onSave()"
              [loading]="saving"
            >
              {{ 'general.save' | translate }}
            </ix-button>
          </ix-col>
        </ix-row>
      </form>
    </ix-layout-grid>
  </div>
}

@if (loading) {
  <div class="d-flex justify-content-center">
    <ix-spinner size="large" class="mt-5"></ix-spinner>
  </div>
}

@if (!passFound) {
  <div class="d-flex justify-content-center">
    <ix-empty-state
      class="mt-5"
      header="{{ 'battery_pass.list.no_passport_available' | translate }}"
      subHeader="{{ 'battery_pass.private.no_pass_sub_header' | translate }}"
      icon="error"
    ></ix-empty-state>
  </div>
}

<ng-template #cancelModal let-modal>
  <div>
    <ix-modal-header id="genericSubmodelEditorCancelModalHeader">
      {{
        (isCreateMode
          ? 'dpp.generic_submodel_editor.cancel.create.modal_headline'
          : 'dpp.generic_submodel_editor.cancel.edit.modal_headline'
        ) | translate
      }}
    </ix-modal-header>
    <ix-modal-content id="genericSubmodelEditorCancelModalContent">
      {{
        (isCreateMode
          ? 'dpp.generic_submodel_editor.cancel.create.modal_content'
          : 'dpp.generic_submodel_editor.cancel.edit.modal_content'
        ) | translate: {id: modal.data}
      }}
    </ix-modal-content>
    <ix-modal-footer>
      <ix-button
        id="genericSubmodelEditorCancelModalYesButton"
        class="dismiss-modal"
        (click)="modal.close(true)"
        onkeypress=""
        variant="secondary"
      >
        {{ 'general.yes' | translate }}
      </ix-button>
      <ix-button
        (click)="modal.dismiss()"
        class="close-modal"
        id="genericSubmodelEditorCancelModalNoButton"
        onkeypress=""
        variant="primary"
      >
        {{ 'general.no' | translate }}
      </ix-button>
    </ix-modal-footer>
  </div>
</ng-template>
